import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import LeadDashboard from './LeadDashboard';
import UserSessionManager from '../../utils/UserSessionManager';
import { UserType } from '../../constants/userTypes';

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboardView, setDashboardView] = useState(UserType.LEAD);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      navigate('/signin');
      return;
    }

    if (UserSessionManager.requiresPasswordChange()) {
      navigate('/changepassword', { state: { forced: true } });
      return;
    }

    const session = UserSessionManager.getSession();

    if (UserSessionManager.isAdmin() || UserSessionManager.isDeveloper()) {
      setDashboardView(UserType.ADMIN);
    } else if (session?.isSubscriber === false) {
      setDashboardView(UserType.LEAD);
    } else {
      navigate('/products');
    }
  }, []);

  return (
    <>
      {dashboardView === UserType.ADMIN ? <AdminDashboard /> : <LeadDashboard />}
    </>
  );
};

export default Dashboard;